module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "todoapp"
  }, [_c('header', {
    staticClass: "header"
  }, [_c('h1', [_vm._v("todos")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTodo),
      expression: "newTodo"
    }],
    staticClass: "new-todo",
    attrs: {
      "autofocus": "",
      "autocomplete": "off",
      "placeholder": "What needs to be done?"
    },
    domProps: {
      "value": (_vm.newTodo)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.addTodo($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTodo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('to-do-list', {
    attrs: {
      "todos": _vm.todos
    }
  }), _vm._v(" "), _c('to-do-footer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.todos.length),
      expression: "todos.length"
    }],
    attrs: {
      "todos": _vm.todos
    },
    on: {
      "remove-completed": _vm.removeCompleted
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-46d42182!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ToDo.vue
// module id = 31
// module chunks = 1